import { render, staticRenderFns } from "./AddOrderMenu.vue?vue&type=template&id=844d35d4&"
import script from "./AddOrderMenu.vue?vue&type=script&lang=js&"
export * from "./AddOrderMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports